import { useAPI } from '../../state';
import { IUploadResponses } from './interface';

const CHECK_FILES = '/api/v1/file/{fileId}';
const UPLOAD_MULTIPLE_FILES = '/api/v1/files';

export const useDeleteUploadFiles = () => {
  return useAPI<IUploadResponses[]>(UPLOAD_MULTIPLE_FILES, {}, 'DELETE');
};

export const useUploadMultipleFiles = () => {
  return useAPI<IUploadResponses[]>(UPLOAD_MULTIPLE_FILES, {}, 'POST');
};

export const useCheckFile = () => {
  return useAPI(CHECK_FILES, {});
};
